import { SvgIcon } from "@mui/material";
import type { DualIconProps } from "shared/types/common";

export const SlaTimerIcon = ({
  primaryColor = "#5563F5",
  secondaryColor = "#B7BDFB",
  activePrimaryColor,
  activeSecondaryColor,
  active = false,
  ...props
}: DualIconProps) => {
  const actPrimary = activePrimaryColor ?? primaryColor;
  const actSecondary = activeSecondaryColor ?? secondaryColor;

  const strokeColor = active ? actPrimary : primaryColor;
  const fillColor = active ? actSecondary : secondaryColor;

  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" role="img" aria-label="SLA timer">
        <circle
          cx="8"
          cy="8.667"
          r="5.333"
          fill={fillColor}
          stroke={strokeColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          stroke={strokeColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
          d="M8.606 5.394a3.306 3.306 0 0 0-3.94 3.273M10.357 6.31l-1.65 1.65"
        />
        <circle
          cx="8"
          cy="8.667"
          r="1"
          stroke={strokeColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          stroke={strokeColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
          d="M6.667 1.333h2.666M13.333 3.333l-1.56 1.56M12.667 2.667 14 4"
        />
      </svg>
    </SvgIcon>
  );
};
